<template>
  <div class="sidebar">
    <div class="sidebar-wrapper">
      <div class="logo">
        <router-link to="/" class="simple-text logo-mini">
          {{ appName ? appName.abbr() : " " }}
        </router-link>
        <router-link to="/" class="simple-text logo-normal">
          {{ appName || "Config Manager" }}
        </router-link>
      </div>
      <ul class="nav">
        <router-link :to="{name: 'Parameters', params:{aid: activeApp}}" tag="li" active-class="active" :class="{ 'disabled': !activeApp }">
          <a href="" :class="{ 'disabled-link': !activeApp }">
            <i class="fas fa-columns"></i>
            <p>Parameters</p>
          </a>
        </router-link>
        <router-link :to="{name: 'ISLKeys', params:{aid: activeApp}}" tag="li" active-class="active" :class="{ 'disabled': !activeApp }" v-if="canAccessISLKeys">
          <a href="" :class="{ 'disabled-link': !activeApp }">
            <i class="fas fa-language"></i>
            <p>ISL</p>
          </a>
        </router-link>
        <router-link :to="{name: 'Audiences', params:{aid: activeApp}}" tag="li" active-class="active" :class="{ 'disabled': !activeApp }">
          <a href="" :class="{ 'disabled-link': !activeApp }">
            <i class="fas fa-users"></i>
            <p>Audiences</p>
          </a>
        </router-link>
        <router-link :to="{name: 'Experiments', params:{aid: activeApp}}" tag="li" active-class="active" :class="{ 'disabled': !activeApp }" v-if="canAccessExperiments">
          <a href="" :class="{ 'disabled-link': !activeApp }">
            <i class="fas fa-flask"></i>
            <p>Experiments</p>
          </a>
        </router-link>
        <router-link :to="{name: 'MessagesMessages', params:{aid: activeApp}}" tag="li" active-class="active" :class="{ 'disabled': !activeApp }" v-if="canAccessMessages">
          <a href="" :class="{ 'disabled-link': !activeApp }">
            <i class="fas fa-comment-alt"></i>
            <p>Messages</p>
          </a>
        </router-link>
        <router-link :to="{name: 'RetentionMessagesTab', params:{aid: activeApp}}" tag="li" active-class="active" :class="{ 'disabled': !activeApp }" v-if="canAccessRetention">
          <a href="" :class="{ 'disabled-link': !activeApp }">
            <i class="fas fa-inbox"></i>
            <p>Retention Messages</p>
          </a>
        </router-link>
        <router-link :to="{name: 'AllExperiments', params:{aid: activeApp}}" tag="li" active-class="active" :class="{ 'disabled': !activeApp }">
          <a href="" :class="{ 'disabled-link': !activeApp }">
            <i class="fas fa-vials"></i>
            <p>All Experiments</p>
          </a>
        </router-link>
        <router-link :to="{name: 'UserCheck', params:{aid: activeApp}}" tag="li" active-class="active" :class="{ 'disabled': !activeApp }">
          <a href="" :class="{ 'disabled-link': !activeApp }">
            <i class="fas fa-user"></i>
            <p>User Check</p>
          </a>
        </router-link>
        <router-link :to="{name: 'TemplateManagement'}" tag="li" active-class="active" :class="{ 'disabled': !activeApp }">
          <a href="" :class="{ 'disabled-link': !activeApp }">
            <i class="fas fa-copy"></i>
            <p>Templates</p>
          </a>
        </router-link>
        <router-link :to="{name: 'Admin'}" tag="li" active-class="active" v-if="userIsAdmin">
          <a href="">
            <i class="fas fa-cog"></i>
            <p>Admin</p>
          </a>
        </router-link>
      </ul>
      <a class="faq-link" href="https://www.notion.so/codewayco/Config-Manager-90197cd353e74999a647aaa7bfaaefad" target="_blank" rel="noopenner noreferrer">
        <i class="fas fa-question-circle"></i>
        <p>FAQ</p>
      </a>
    </div>
    
  </div>
</template>

<script>
import { permissionsMixin } from '../mixins/permissions.mixin';

export default {
  mixins: [permissionsMixin],
  computed: {
    activeApp() {
      return this.$store.getters.activeApp
    },
    appName() {
      const apps = this.$store.getters.apps
      return apps[this.activeApp]
    },
    user() {
      return this.$store.getters.user
    },
    canAccessMessages() {
      // Use mixin getters for message permissions
      return this.canSendPushNotifications || 
             this.canSchedulePushNotifications || 
             this.canCreateDraftMessages ||
             this.userIsAdmin;
    },
    canAccessISLKeys() {
      // Use mixin getter for ISL permissions
      return this.canViewISLKeys || this.userIsAdmin;
    },
    canAccessExperiments() {
      // Use mixin getter for experiments permissions
      return this.canViewExperiments || this.userIsAdmin;
    },
    canAccessRetention() {
      return this.canAccessRetentionMessages || this.userIsAdmin;
    }
  }
}
</script>

<style scoped>

.sidebar-wrapper{
  position: relative;
}

div.sidebar  >.sidebar-wrapper > a.faq-link{
  margin: 10px 15px 0;
    border-radius: 30px;
    color: #ffffff;
    display: flex;
    margin-top: auto;
    text-decoration: none;
    position: absolute;
    text-transform: uppercase;
    cursor: pointer;
    font-size: 0.62475rem;
    padding: 10px 8px;
    line-height: 1.625rem;
    justify-content: center;
    bottom: 0;
}

a.faq-link > i {
  font-size: 20px;
    float: left;
    margin-right: 12px;
    line-height: 30px;
    width: 34px;
    text-align: center;
    color: rgba(255, 255, 255, 0.8);
    position: relative;
}

.sidebar .faq-link > p {
 
  opacity: 0;
  transition: opacity 0.5s;
}
.sidebar:hover .faq-link > p {
display: flex;
opacity: 1;
}

/* Disabled sidebar links */
.sidebar .nav li.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.sidebar .nav li.disabled a.disabled-link {
  cursor: not-allowed;
  color: rgba(255, 255, 255, 0.4) !important;
}

.sidebar .nav li.disabled a.disabled-link:hover {
  background: none !important;
  color: rgba(255, 255, 255, 0.4) !important;
}
</style>